export interface AccountReducer {
  account: {
    mpAuthToken?: string
  }
}

export const CUSTOM_TOKEN_HEADER = 'X-Oddle-Pass-Token'
export const CUSTOM_CLIENT_ID_HEADER = 'X-Oddle-Pass-Client-Id'
export const CUSTOM_REQUEST_ID_HEADER = 'X-Request-Id'

export const OMS_REDUCER_PATH = 'oms'
export const OMS_API_ENDPOINT =
  process.env.NEXT_PUBLIC_V3_API_TARGET || 'https://api.beta.oddle.me'

export const OVERRIDE_EXISTING = process.env.NODE_ENV !== 'production'
